'use client';

import { useRef } from 'react';
import Script from 'next/script';

import { TRUSTPILOT_REVIEWS_URL } from '@utils/constants';

export const TrustpilotReviewCarousel = (): React.JSX.Element => {
  const widgetElementRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Script
        id="trustpilot-widget-script"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="lazyOnload"
        // The bootstrap only scans the DOM when it first runs, so a widget
        // mounted by client-side navigation has to be loaded explicitly.
        onReady={() => {
          if (widgetElementRef.current) {
            window.Trustpilot?.loadFromElement(widgetElementRef.current);
          }
        }}
      />
      <div
        ref={widgetElementRef}
        className="trustpilot-widget w-full"
        data-locale="en-US"
        data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="6814e6ec96bb8d7784e2e2ec"
        data-style-height="140px"
        data-style-width="100%"
        data-token="8319b6db-2e70-4702-a165-b7d0cd5467a6"
        data-stars="5"
        data-review-languages="en"
      >
        <a href={TRUSTPILOT_REVIEWS_URL} target="_blank" rel="noopener">
          Trustpilot
        </a>
      </div>
    </>
  );
};
